// extracted by mini-css-extract-plugin
export default {"container":"ShowImgModal_container__Z9HNy","img__container":"ShowImgModal_img__container__Xnvln","figure":"ShowImgModal_figure__+wRpN","loading":"ShowImgModal_loading__47HDb"};